import React from 'react'
import { useScriptWithConsent, ScriptLoadResult } from 'common/hooks/useScriptWithConsent'
import { ConsentLevel } from 'common/data/consent/consent.redux'
import { ConsentFallback } from 'component-library/tracking/ConsentFallback/ConsentFallback'

export interface Props {
    user: string
    height: string
}

type twttrScript = {
    widgets: {
        load: () => void
    }
}

declare const twttr: twttrScript

const checkTwitter = () => typeof twttr !== 'undefined' && twttr && twttr.widgets

export const TwitterTimeline: React.FC<Props> = ({ user, height }) => {
    const requiredConsentLevel = ConsentLevel.Analytics | ConsentLevel.Advertising

    const [result, error] = useScriptWithConsent({
        consentRequiredLevel: requiredConsentLevel,
        consentMet: { src: 'https://platform.twitter.com/widgets.js' },
    })

    React.useEffect(() => {
        if (result === ScriptLoadResult.Success && checkTwitter()) {
            twttr.widgets.load()
        }
    }, [result, error])

    if (!user) {
        return null
    }

    if (result === ScriptLoadResult.NotConsented) {
        return <ConsentFallback />
    }

    const link = `https://twitter.com/${user}?ref_src=twsrc%5Etfw`

    return (
        <div>
            <a className="twitter-timeline" data-height={height} href={link}>
                Tweets by {user}
            </a>
        </div>
    )
}
